<!-- <ng-container  *ngIf="offers?.length"> -->

<table [hidden]="isLoading" mat-table aria-label="tableau vitrine du club" [dataSource]="dataSource" matSort
  multiTemplateDataRows class="mat-elevation-z8">

  <ng-container matColumnDef="offerKey">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="offerKey" class="cell_offerKey">N° de l'article</th>
    <td mat-cell *matCellDef="let element"> {{element.offerKey}} </td>
  </ng-container>

  <ng-container matColumnDef="offerName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="offerName" class="cell_text">
      <app-pop-up-filter idFilter="popup_filter_offer_name" column="offername"
        [offers]="getDataToCheckBox('offername')">
      </app-pop-up-filter>
      Nom de l'article
    </th>
    <td mat-cell *matCellDef="let element" class="cell_text"> {{element.offerName}} </td>
  </ng-container>

  <!-- <ng-container matColumnDef="price">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="price" class="cell_id">
      <app-pop-up-filter idFilter="popup_filter_offer_price" column="price" [offers]="getDataToCheckBox('price')">
      </app-pop-up-filter>
      Prix
    </th>
    <td mat-cell *matCellDef="let element" class="cell_id"> {{element.price}} </td>
  </ng-container>

  <ng-container matColumnDef="backoffice">
    <th mat-header-cell *matHeaderCellDef class="cell_backoffice"> BackOffice </th>
    <td mat-cell *matCellDef="let element" class="cell_backoffice">
      <fa-icon *ngIf="!element.isExternalOffer" [icon]="getFaIcon('faCheckCircle')" appChangeColorTheme
        attribute="color"></fa-icon>
    </td>
  </ng-container> -->

  <ng-container matColumnDef="articleType">
    <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell_text">Type de l'article</th>
    <td mat-cell *matCellDef="let element" class="cell_text"> {{ element.universes ? element.universes[0].universeName : null }} </td>
  </ng-container>

  <ng-container matColumnDef="file">
    <th mat-header-cell *matHeaderCellDef class="cell_session">Fichiers</th>
    <td mat-cell *matCellDef="let element" class="cell_session">
      <fa-icon [icon]="getFaIcon('faFile')" [matTooltip]="getTooltip('goToFilesOffer')"
        (click)="goToFilesOffer(element)" appChangeColorTheme attribute="color">
      </fa-icon>
    </td>
  </ng-container>

  <!-- <ng-container matColumnDef="session">
    <th mat-header-cell *matHeaderCellDef class="cell_session">Sessions</th>
    <td mat-cell *matCellDef="let element" class="cell_session">
      <ng-container *ngIf="!element?.isExternalOffer && element.hasSession">
        <span *ngIf="element.sessions?.length " [matTooltip]="getTooltip('showSessionOffer')"
          (click)="$event.preventDefault(); addSession(element)" appChangeColorTheme attribute="color">
          {{getLengthSession(element.sessions).length}} </span>
        <fa-icon *ngIf="!element.sessions?.length " [matTooltip]="getTooltip('addSessionOffer')"
          [icon]="getFaIcon('faPlus')" (click)="$event.preventDefault(); addSession(element)" appChangeColorTheme
          attribute="color"></fa-icon>
      </ng-container>
    </td>
  </ng-container> -->

  <ng-container matColumnDef="duplicate">
    <th mat-header-cell *matHeaderCellDef class="cell_action"> Dupliquer </th>
    <td mat-cell *matCellDef="let element" class="cell_action">
      <fa-icon [icon]="getFaIcon('faCopy')" (click)="duplicateOffer(element)"
        [matTooltip]="getTooltip('duplicateOffer')" appChangeColorTheme attribute="color">
      </fa-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="edit">
    <th mat-header-cell *matHeaderCellDef class="cell_action"> Éditer </th>
    <td mat-cell *matCellDef="let element" class="cell_action">
      <ng-container *ngIf="element.ownerKey === userKey">
        <fa-icon [icon]="getFaIcon('faPen')" (click)="$event.preventDefault(); editOffer(element, 'description')"
                  [matTooltip]="getTooltip('editOffer')" appChangeColorTheme attribute="color"></fa-icon>
      </ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="link">
    <th mat-header-cell *matHeaderCellDef class="cell_action"> Lien </th>
    <td mat-cell *matCellDef="let element" class="cell_action">
      <fa-icon [icon]="getFaIcon('faLink')" [matTooltip]="'Copier le lien de l\'offre'"
        (click)="copyString(element.offerKey)" appChangeColorTheme attribute="color"></fa-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="isActive">
    <th mat-header-cell mat-sort-header="isActive" *matHeaderCellDef class="cell_active"> Act./Dés. </th>
    <td mat-cell *matCellDef="let element" class="cell_active">
      <ng-container *ngIf="element.ownerKey === userKey">
        <mat-slide-toggle size="large" (toggleChange)="isActivatedOrDeactivated(element)" [color]="color"
                        [checked]="element?.isActive"></mat-slide-toggle>
      </ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="favoris">
    <th mat-header-cell mat-sort-header="isPriority" *matHeaderCellDef class="cell_favorite"
      [style.text-align]="'right !important'"> Prioritaire </th>
    <td mat-cell *matCellDef="let element" class="cell_favorite">
      <fa-icon *ngIf="element?.isActive" class="faStar"
        [icon]="element.isPriority ? getFaIcon('faStarFull') : getFaIcon('faStarEmpty')"
        (click)="addOfferToPriority(element, element?.isPriority)" appChangeColorTheme attribute="color">
      </fa-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="rating">
    <th mat-header-cell mat-sort-header="rating" *matHeaderCellDef class="cell_rating"> Note </th>
    <td mat-cell *matCellDef="let element" class="cell_rating">
      <ng-container *ngIf="element.ratingTotal > 0">{{element.rating}}
        <sup *ngIf="element.ratingTotal > 1">
          <fa-icon class="faInfoCircle" [icon]="getFaIcon('faInfoCircle')"
            [matTooltip]="'Moyenne des ' + element.ratingTotal + ' notes réalisées par les utilisateurs de l\'activité'"
            appChangeColorTheme attribute="color"></fa-icon>
        </sup>
      </ng-container>
    </td>
  </ng-container>

  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" colspan="9999">
      No data matching the filter
    </td>
  </tr>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; let element; columns: displayedColumns"
    [style.opacity]=" !offerSelected || (element.offerKey === offerSelected?.offerKey)  ? 1: .6"
    (click)="closePopUp(); changePreview(element)">
  </tr>
</table>

<div [hidden]="isLoading">
  <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event"
    [color]="color">
  </mat-paginator>
</div>


<mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>

<!-- </ng-container> -->


<!-- <p *ngIf="!offers?.length" class="no_offers">Il n'y a pas d'offre pour votre club.</p> -->
